import Language from "../data/Language";

export default class LanguageService {
	static async getLanguages() {
		return Object.values(Language);
	}
}
